import React, { useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { fetchListPromotionRequest } from "redux/ActionCreators/PromotionActionCreators";
import OfferCategoriesItem from "../OfferCategoriesItem/OfferCategoriesItem";

const imageStyles = [
  {
    width: "30%",
  },
  {
    width: "40%",
  },
  {
    width: "30%",
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    margin: "auto",
  },
}));

const OfferCategoriesList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const promotions = useSelector((state) => state.promotions.list);
  useEffect(() => {
    dispatch(fetchListPromotionRequest());
  }, []);

  if (!promotions) return <div>Loading...</div>;
  return (
    <div className={classes.root}>
      {promotions.map((promotion, index) => (
        <OfferCategoriesItem
          key={index}
          id={promotion.id}
          imgPath={promotion.imgPath}
          name={promotion.name}
          percent={promotion.percent}
          width={imageStyles[index].width}
        />
      ))}
    </div>
  );
};

export default OfferCategoriesList;
